import type { RouteObject } from 'react-router';
import { AcceptTermsPage } from './accept-terms-page';
import { PrivacyPage, TermsPage } from './legal-page';

/** Páginas públicas (sem login) e a tela de aceite (exige login, fora do layout do app). */
export const publicRoutes: RouteObject[] = [
  { path: 'privacidade', element: <PrivacyPage /> },
  { path: 'termos', element: <TermsPage /> },
  { path: 'aceitar-termos', element: <AcceptTermsPage /> },
];
